import axios from '../services/index';
import { setUser, alertError } from './stateActions';
import { getCMSAPIUrl } from '../utils/urlFactory';

export const fetchUser = (id, jwt, role, hospital) => (dispatch, getState) => {
    const strapiToken = getState().strapiToken;

    axios
        .post(
            `${getCMSAPIUrl()}/graphql`,
            {
                query: `query GET_USER{user(id: "${id}"){
                  id
                  uuid
                  session
                  username
                  fullname
                  email
                  gender
                  mobileNumber
                  birthday
                  avatar {
                    id
                    url
                  }
                  staff {
                    id
                    deactivated
                    title1 {
                      name
                    }
                    title2 {
                      name
                    }
                    staff_position {
                      name
                    }
                    staff_role {
                      name
                    }
                    specialist
                    hospital {
                      id
                      name
                      avatar {
                        url
                      }
                    }
                  }
                  patients {
                    id
                    published_at
                    patientTag
                    HNCode
                    hospital {
                      id
                      name
                      avatar {
                        url
                      }
                    }
                  }
            }}`,
            },
            {
                headers: {
                    authorization: `Bearer ${jwt || strapiToken}`,
                },
            }
        )
        .then((res) => {
            if (res.data.errors) {
                localStorage.clear();
                window.location.replace('/signin');
                dispatch(alertError(`Cannot get User Profile: ${res.data.errors[0].message}`));
                return;
            }

            const user = res.data.data.user;

            const session = localStorage.getItem('session');

            if (!user) {
                localStorage.clear();
                window.location.replace('/signin');
            }

            if (role === 'Patient') {
                const foundPatients = user.patients.find((p) => p.hospital.id === hospital);

                if (!foundPatients || (session && session !== user.session)) {
                    localStorage.clear();
                    window.location.replace('/signin');
                }

                user.patient = foundPatients;
                delete user.patients;
                delete user.staff;
                localStorage.setItem('role', 'Patient');
            }
            if (['Staff', 'Provider', 'Admin', 'Provider Admin'].includes(role)) {
                const foundStaff = user.staff.find((p) => p.hospital.id === hospital);

                if (!foundStaff || (session && session !== user.session)) {
                    localStorage.clear();
                    window.location.replace('/provider/signin');
                }

                user.staff = foundStaff;
                delete user.patients;
                localStorage.setItem('role', user.staff.staff_role.name);
            }

            // console.log('user', user);
            dispatch(setUser(user));
        })
        .catch((error) => {
            console.log('error', error);
            dispatch(alertError(`get User Profile Error: ${error}`));
        });
};
